import { useEffect, useState } from "react";
import { Logo } from "./Logo";
import { scrollToId } from "@/lib/checkout";
import { BuyButton } from "./BuyButton";

const links = [
    { id: "pacchetto", label: "Il prodotto", testId: "nav-link-pacchetto" },
    { id: "anteprima", label: "Anteprime", testId: "nav-link-anteprima" },
    { id: "faq", label: "FAQ", testId: "nav-link-faq" },
    { id: "contatti", label: "Contatti", testId: "nav-link-contatti", route: "/contatti" },
];

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,box-shadow] duration-500 ${
                scrolled ? "border-b border-slate-200 bg-white/90 shadow-sm backdrop-blur-xl" : "bg-white/0"
            }`}
        >
            <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
                <button onClick={() => window.__lenis?.scrollTo(0)} className="text-left" aria-label="Torna su">
                    <Logo compact={scrolled} onDark={!scrolled} />
                </button>
                <nav className="hidden items-center gap-8 lg:flex">
                    {links.map((l) =>
                        l.route ? (
                            <a
                                key={l.id}
                                href={l.route}
                                data-testid={l.testId}
                                className={`text-sm font-semibold transition-colors duration-300 hover:text-gold ${
                                    scrolled ? "text-navy-950" : "text-slate-200"
                                }`}
                            >
                                {l.label}
                            </a>
                        ) : (
                            <button
                                key={l.id}
                                data-testid={l.testId}
                                onClick={() => scrollToId(l.id)}
                                className={`text-sm font-semibold transition-colors duration-300 hover:text-gold ${
                                    scrolled ? "text-navy-950" : "text-slate-200"
                                }`}
                            >
                                {l.label}
                            </button>
                        ),
                    )}
                </nav>
                <BuyButton
                    testId="nav-cta-header-buy"
                    label="Ottieni le 3 simulazioni"
                    className="!px-4 !py-2.5 text-xs sm:text-sm hidden sm:inline-flex"
                />
            </div>
        </header>
    );
};
